import React from 'react';
import './QuienesSomos.css';

const teamMembers = [
  {
    name: 'Juan Isidro Pimentel',
    role: 'Fundador & Director',
    description: 'Activista comprometido con la búsqueda de personas desaparecidas en República Dominicana.',
    emoji: '👨‍💼'
  },
  {
    name: 'Equipo de Voluntarios',
    role: 'Red de Apoyo',
    description: 'Ciudadanos comprometidos que dedican su tiempo a difundir casos y apoyar a las familias.',
    emoji: '🤝'
  },
  {
    name: 'Colaboradores Comunitarios',
    role: 'Red Nacional',
    description: 'Personas en todo el país que ayudan a compartir información y localizar personas desaparecidas.',
    emoji: '🌐'
  }
];

const values = [
  {
    icon: '❤️',
    title: 'Humanidad',
    description: 'Cada persona desaparecida es una familia que sufre. Trabajamos con empatía y respeto por cada caso.'
  },
  {
    icon: '⚡',
    title: 'Urgencia',
    description: 'Las primeras horas son críticas. Actuamos rápido para maximizar las posibilidades de encontrar a cada persona.'
  },
  {
    icon: '🔒',
    title: 'Privacidad',
    description: 'Manejamos la información de cada caso con discreción y respeto hacia las familias afectadas.'
  },
  {
    icon: '🤝',
    title: 'Solidaridad',
    description: 'Creemos en el poder de la comunidad. Unidos podemos lograr lo que individualmente es imposible.'
  },
  {
    icon: '✅',
    title: 'Transparencia',
    description: 'Operamos con honestidad total. Las familias merecen información clara y veraz en todo momento.'
  },
  {
    icon: '🆓',
    title: 'Gratuidad',
    description: 'Nuestros servicios son completamente gratuitos. Nadie debe pagar por buscar a un ser querido.'
  }
];

export default function QuienesSomosPage() {
  return (
    <div className="qs-page">

      {/* Hero */}
      <section className="qs-hero">
        <div className="qs-hero-inner">
          <div className="qs-hero-badge">🔍 Nuestra Historia</div>
          <h1>Quiénes <span className="qs-accent">Somos</span></h1>
          <p className="qs-hero-sub">
            VuelveACasa RD es una plataforma digital sin fines de lucro dedicada a la búsqueda
            de personas desaparecidas en la República Dominicana. Nacimos de la necesidad de
            crear un espacio centralizado donde las familias puedan publicar casos y la comunidad
            pueda colaborar en encontrar a sus seres queridos.
          </p>
        </div>
      </section>

      {/* Stats rápidos */}
      <section className="qs-stats">
        <div className="qs-stats-inner">
          <div className="qs-stat-item">
            <span className="qs-stat-num">55+</span>
            <span className="qs-stat-label">Casos Registrados</span>
          </div>
          <div className="qs-stat-item">
            <span className="qs-stat-num">16+</span>
            <span className="qs-stat-label">Personas Encontradas</span>
          </div>
          <div className="qs-stat-item">
            <span className="qs-stat-num">2024</span>
            <span className="qs-stat-label">Año de Fundación</span>
          </div>
          <div className="qs-stat-item">
            <span className="qs-stat-num">100%</span>
            <span className="qs-stat-label">Gratuito</span>
          </div>
        </div>
      </section>

      {/* Misión & Visión */}
      <section className="qs-mission">
        <div className="qs-mission-inner">
          <div className="qs-mission-card">
            <div className="qs-mission-icon">🎯</div>
            <h2>Nuestra Misión</h2>
            <p>
              Facilitar la búsqueda de personas desaparecidas en República Dominicana mediante
              tecnología accesible y la movilización ciudadana, proporcionando a las familias
              una plataforma gratuita, rápida y confiable donde puedan publicar y difundir
              casos de manera efectiva.
            </p>
          </div>
          <div className="qs-mission-card">
            <div className="qs-mission-icon">👁️</div>
            <h2>Nuestra Visión</h2>
            <p>
              Ser la plataforma de referencia en República Dominicana para la búsqueda de
              personas desaparecidas, construyendo una red nacional de solidaridad donde
              ninguna familia tenga que enfrentar sola la angustia de buscar a un ser querido.
            </p>
          </div>
        </div>
      </section>

      {/* Cómo funciona */}
      <section className="qs-how">
        <div className="qs-how-inner">
          <h2 className="qs-section-title">¿Cómo <span className="qs-accent">Funcionamos?</span></h2>
          <div className="qs-steps">
            <div className="qs-step">
              <div className="qs-step-num">1</div>
              <h3>Reporte del Caso</h3>
              <p>La familia o conocidos de la persona desaparecida nos contactan con los datos y fotos del caso.</p>
            </div>
            <div className="qs-step-arrow">→</div>
            <div className="qs-step">
              <div className="qs-step-num">2</div>
              <h3>Publicación Inmediata</h3>
              <p>Publicamos el caso en nuestra plataforma web y redes sociales para maximizar la difusión.</p>
            </div>
            <div className="qs-step-arrow">→</div>
            <div className="qs-step">
              <div className="qs-step-num">3</div>
              <h3>Movilización</h3>
              <p>La comunidad comparte, aporta información y colabora activamente en la búsqueda.</p>
            </div>
            <div className="qs-step-arrow">→</div>
            <div className="qs-step">
              <div className="qs-step-num">4</div>
              <h3>Reunificación</h3>
              <p>Cuando la persona es encontrada, actualizamos el caso y celebramos junto a la familia.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="qs-values">
        <div className="qs-values-inner">
          <h2 className="qs-section-title">Nuestros <span className="qs-accent">Valores</span></h2>
          <div className="qs-values-grid">
            {values.map((v, i) => (
              <div key={i} className="qs-value-card">
                <div className="qs-value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipo */}
      <section className="qs-team">
        <div className="qs-team-inner">
          <h2 className="qs-section-title">Nuestro <span className="qs-accent">Equipo</span></h2>
          <p className="qs-team-sub">
            Somos ciudadanos dominicanos comprometidos con la causa de encontrar a nuestros seres queridos.
          </p>
          <div className="qs-team-grid">
            {teamMembers.map((m, i) => (
              <div key={i} className="qs-team-card">
                <div className="qs-team-avatar">{m.emoji}</div>
                <h3>{m.name}</h3>
                <span className="qs-team-role">{m.role}</span>
                <p>{m.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="qs-cta">
        <div className="qs-cta-inner">
          <h2>¿Necesitas reportar un caso?</h2>
          <p>Si tienes un familiar o conocido desaparecido, contáctanos de inmediato. Estamos aquí para ayudarte.</p>
          <div className="qs-cta-buttons">
            <a href="/reportar" className="qs-btn-primary">📋 Reportar Caso</a>
            <a href="/contacto" className="qs-btn-secondary">💬 Contáctanos</a>
          </div>
        </div>
      </section>

    </div>
  );
}
